import { FieldContinuationDataForResolver } from "db/definitions";

function enforceContinuationData(
	continuationData: Partial<Omit<FieldContinuationDataForResolver, "id" | "parentFormTemplateId" | "group" | "readGroups">> & {
		group: string;
		id: string;
		parentFormTemplateId: string;
		readGroups: string[];
	},
): FieldContinuationDataForResolver {
	const newContinuationData: FieldContinuationDataForResolver = {
		id: continuationData.id,
		continuationActions: continuationData.continuationActions || [],
		fieldTemplateId: continuationData.fieldTemplateId || "",
		formTemplateId: continuationData.formTemplateId || "",
		instanceToContinueOn: continuationData.instanceToContinueOn || "",
		parentFormTemplateId: continuationData.parentFormTemplateId,
		group: continuationData.group,
		readGroups: [...continuationData.readGroups],
		createdAt: new Date().toISOString(),
		updatedAt: new Date().toISOString(),
	};

	return newContinuationData;
}

export default enforceContinuationData;
